import axios from 'axios';

import { API } from '@/config/constants';


export const getPublicShopBranding = async (config = {}, backendUrl) => {
  const endpoint = `${backendUrl ? `${backendUrl}/api` : API}/public/shop-branding`;
  const response = Object.keys(config).length
    ? await axios.get(endpoint, config)
    : await axios.get(endpoint);
  return response.data;
};

export const getShopSettings = async (config) => {
  const response = await axios.get(`${API}/shop-settings`, ...config ? [config] : []);
  return response.data;
};

export const updateShopSettings = async (data, config) => {
  const response = await axios.post(`${API}/shop-settings`, data, ...config ? [config] : []);
  return response.data;
};

export const uploadShopLogo = async (file, config = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API}/shop-settings/logo`, formData, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data', ...config.headers },
  });
  return response.data;
};

export const deleteShopLogo = async (config) => {
  const response = await axios.delete(`${API}/shop-settings/logo`, ...config ? [config] : []);
  return response.data;
};
